export default __webpack_public_path__ + "static/media/img11.b3b59e9f.png";